var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-wrap", class: _vm.alignmentClass },
    [
      _vm.noContent
        ? _c("div", { staticClass: "text-sm font-semibold" }, [_vm._v("n/a")])
        : _vm._e(),
      _vm._l(_vm.groupsToRender, function ({ id, name, contractorsCount }) {
        return _c(
          "ItemChip",
          {
            key: id,
            attrs: {
              itemId: id,
              itemName: name,
              routeName: _vm.routeNames.GROUP_DETAILS,
            },
          },
          [
            _vm.isContractorsExist(contractorsCount)
              ? _c("span", { staticClass: "truncate" }, [
                  _vm._v(
                    " " + _vm._s(name) + " (" + _vm._s(contractorsCount) + ") "
                  ),
                ])
              : _vm._e(),
          ]
        )
      }),
      _vm.groupsMoreThanLimit
        ? _c(
            "div",
            { staticClass: "ml-2 inline-block" },
            [
              _vm.navigateTo
                ? [
                    _c("RouterLink", { attrs: { to: _vm.navigateTo } }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "truncate text-primary-500 cursor-pointer",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.groups.length - _vm.limit) +
                              " more... "
                          ),
                        ]
                      ),
                    ]),
                  ]
                : [
                    _c("span", { staticClass: "truncate" }, [
                      _vm._v(
                        _vm._s(_vm.groups.length - _vm.limit) + " more..."
                      ),
                    ]),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }